import {Input, Tooltip} from 'antd';
import React, {FC} from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {TIconType} from 'components/dynamic-icon/dynamic-icon';
import {DEFAULT_ICON_COLOR} from 'components/table/columns/icons-cell/icon-cell.constants';
import {IFieldMeta, TFieldStructureType} from 'entities/metadata';
import {ReactComponent as Lock} from 'shared/assets/forms/lock.svg';
import './input-tooltip.less';

interface IInputTooltipProps {
    disabled?: boolean;
    field?: IFieldMeta;
    value?: any;
    defaultValue?: string;
    placeholder?:string;
    fieldStructure?: TFieldStructureType[];
}

export const InputTooltip: FC<IInputTooltipProps> = (
    {
        disabled,
        field,
        value,
        fieldStructure,
        ...props
    }: IInputTooltipProps,
) => {
    const suffix = disabled ? <Lock /> : null;
    return (
        <div className="input-tooltip">
            <Input
                disabled={disabled}
                suffix={suffix}
                value={value || field?.defaultValue}
                {...props}
            />
            <div className="tooltip-list">
                {fieldStructure?.map(fieldStructureEl => (
                    <Tooltip
                        key={fieldStructureEl?.fieldKey}
                        placement="top"
                        title={value}
                    >
                        <DynamicIcon
                            style={
                                {
                                    fontSize: fieldStructureEl?.iconSize || 16,
                                    color: fieldStructureEl?.iconColor || DEFAULT_ICON_COLOR,
                                }
                            }
                            type={fieldStructureEl?.iconName as TIconType}
                        />
                    </Tooltip>
                ))}
            </div>
        </div>

    );
};
